/* tslint:disable */
/* eslint-disable */
/**
 * Payment Schedule API
 * API to manage payment schedules (échéances de paiement)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentScheduleHistoryItemDto } from './PaymentScheduleHistoryItemDto';
import {
    PaymentScheduleHistoryItemDtoFromJSON,
    PaymentScheduleHistoryItemDtoFromJSONTyped,
    PaymentScheduleHistoryItemDtoToJSON,
    PaymentScheduleHistoryItemDtoToJSONTyped,
} from './PaymentScheduleHistoryItemDto';
import type { PaymentScheduleSubscriberDto } from './PaymentScheduleSubscriberDto';
import {
    PaymentScheduleSubscriberDtoFromJSON,
    PaymentScheduleSubscriberDtoFromJSONTyped,
    PaymentScheduleSubscriberDtoToJSON,
    PaymentScheduleSubscriberDtoToJSONTyped,
} from './PaymentScheduleSubscriberDto';

/**
 * Global information about a payment schedule (header + contract payment history for side menu)
 * @export
 * @interface GetEcheanceGlobalInfoResponse
 */
export interface GetEcheanceGlobalInfoResponse {
    /**
     * Type de quittance, déjà libellé par le back : « Comptant », « Terme », « Sinistre » ou « Résiliation ». Chaîne prête à afficher, aucun code à traduire — un contrat nouvellement souscrit est toujours en « Comptant ».
     * @type {string}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    receiptType?: string | null;
    /**
     * Unique identifier of the payment schedule
     * @type {string}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    id: string;
    /**
     * Payment number in the schedule sequence
     * @type {number}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    paymentNumber: number;
    /**
     * Due date of the payment
     * @type {Date}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    dueDate: Date;
    /**
     * Total payment amount
     * @type {number}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    amount: number;
    /**
     * Current status of the payment schedule (Planifie, Pending, Paid, Failed, Cancelled, Refunded)
     * @type {string}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    status: string;
    /**
     * Hex color code for the status badge
     * @type {string}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    statusColor?: string | null;
    /**
     * Date when the status was last updated
     * @type {Date}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    statusDate?: Date | null;
    /**
     * Pure premium amount
     * @type {number}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    purePremium: number;
    /**
     * Commission amount
     * @type {number}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    commissions: number;
    /**
     * Tax amount
     * @type {number}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    tax: number;
    /**
     * Fees amount
     * @type {number}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    fees: number;
    /**
     * 
     * @type {PaymentScheduleSubscriberDto}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    subscriber: PaymentScheduleSubscriberDto;
    /**
     * Contract number
     * @type {string}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    contractNumber: string;
    /**
     * Name of the associated product
     * @type {string}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    productName: string;
    /**
     * Payment history for the associated contract (used in side menu navigation)
     * @type {Array<PaymentScheduleHistoryItemDto>}
     * @memberof GetEcheanceGlobalInfoResponse
     */
    contractPaymentHistory: Array<PaymentScheduleHistoryItemDto>;
}

/**
 * Check if a given object implements the GetEcheanceGlobalInfoResponse interface.
 */
export function instanceOfGetEcheanceGlobalInfoResponse(value: object): value is GetEcheanceGlobalInfoResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('paymentNumber' in value) || value['paymentNumber'] === undefined) return false;
    if (!('dueDate' in value) || value['dueDate'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('purePremium' in value) || value['purePremium'] === undefined) return false;
    if (!('commissions' in value) || value['commissions'] === undefined) return false;
    if (!('tax' in value) || value['tax'] === undefined) return false;
    if (!('fees' in value) || value['fees'] === undefined) return false;
    if (!('subscriber' in value) || value['subscriber'] === undefined) return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('contractPaymentHistory' in value) || value['contractPaymentHistory'] === undefined) return false;
    return true;
}

export function GetEcheanceGlobalInfoResponseFromJSON(json: any): GetEcheanceGlobalInfoResponse {
    return GetEcheanceGlobalInfoResponseFromJSONTyped(json, false);
}

export function GetEcheanceGlobalInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEcheanceGlobalInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'receiptType': json['receiptType'] == null ? undefined : json['receiptType'],
        'id': json['id'],
        'paymentNumber': json['paymentNumber'],
        'dueDate': (new Date(json['dueDate'])),
        'amount': json['amount'],
        'status': json['status'],
        'statusColor': json['statusColor'] == null ? undefined : json['statusColor'],
        'statusDate': json['statusDate'] == null ? undefined : (new Date(json['statusDate'])),
        'purePremium': json['purePremium'],
        'commissions': json['commissions'],
        'tax': json['tax'],
        'fees': json['fees'],
        'subscriber': PaymentScheduleSubscriberDtoFromJSON(json['subscriber']),
        'contractNumber': json['contractNumber'],
        'productName': json['productName'],
        'contractPaymentHistory': ((json['contractPaymentHistory'] as Array<any>).map(PaymentScheduleHistoryItemDtoFromJSON)),
    };
}

export function GetEcheanceGlobalInfoResponseToJSON(json: any): GetEcheanceGlobalInfoResponse {
    return GetEcheanceGlobalInfoResponseToJSONTyped(json, false);
}

export function GetEcheanceGlobalInfoResponseToJSONTyped(value?: GetEcheanceGlobalInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'receiptType': value['receiptType'],
        'id': value['id'],
        'paymentNumber': value['paymentNumber'],
        'dueDate': ((value['dueDate']).toISOString()),
        'amount': value['amount'],
        'status': value['status'],
        'statusColor': value['statusColor'],
        'statusDate': value['statusDate'] == null ? undefined : ((value['statusDate'] as any).toISOString()),
        'purePremium': value['purePremium'],
        'commissions': value['commissions'],
        'tax': value['tax'],
        'fees': value['fees'],
        'subscriber': PaymentScheduleSubscriberDtoToJSON(value['subscriber']),
        'contractNumber': value['contractNumber'],
        'productName': value['productName'],
        'contractPaymentHistory': ((value['contractPaymentHistory'] as Array<any>).map(PaymentScheduleHistoryItemDtoToJSON)),
    };
}

